import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import { FEATURED } from "@/constants/testIds";

export default function FeaturedTrees() {
  const [trees, setTrees] = useState([]);

  useEffect(() => {
    api.get("/family-trees").then((r) => setTrees(r.data.trees || [])).catch(() => setTrees([]));
  }, []);

  return (
    <section
      id="featured"
      data-testid={FEATURED.root}
      className="relative py-28 md:py-40"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between gap-6 flex-wrap">
          <div>
            <span className="text-xs uppercase tracking-[0.3em] text-saffron">From the network</span>
            <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink leading-[0.95]">
              Featured
              <span className="italic text-tulsi"> Indian </span>
              family trees.
            </h2>
          </div>
          <a href="#final-cta" data-testid={FEATURED.viewAll} className="ink-link text-sm text-ink-50 hover:text-ink">
            View all archives →
          </a>
        </div>

        <div className="mt-14 grid grid-cols-12 gap-6 md:gap-8">
          {trees.map((t, i) => (
            <motion.article
              key={t.id}
              data-testid={FEATURED.card(t.id)}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative col-span-12 sm:col-span-6 lg:col-span-4 ${i === 0 ? "lg:col-span-6" : ""} ${i === 1 ? "lg:col-span-6" : ""}`}
            >
              <div className="relative overflow-hidden border border-ivory-300 rounded-xl bg-ivory">
                <div className={`overflow-hidden ${i < 2 ? "h-[380px]" : "h-[280px]"}`}>
                  <img
                    src={t.cover}
                    alt={t.family_name}
                    className="w-full h-full object-cover grayscale-[0.15] sepia-[0.1] group-hover:scale-[1.04] group-hover:grayscale-0 transition-transform duration-[900ms] ease-out"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-ink/70 via-ink/20 to-transparent pointer-events-none" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8">
                  <div className="flex items-center gap-3 text-[10px] tracking-[0.28em] uppercase text-ivory/80">
                    <span>{t.state}</span>
                    <span className="w-4 h-px bg-ivory/40" />
                    <span>{t.district}</span>
                  </div>
                  <h3 className="mt-2 font-serif text-2xl md:text-3xl text-ivory tracking-tight leading-tight">
                    {t.family_name}
                  </h3>
                  <p className="mt-2 text-ivory/80 text-sm max-w-md font-light hidden md:block">
                    {t.story}
                  </p>
                  <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-1 text-xs text-ivory/70">
                    <span><b className="text-ivory">{t.generations}</b> generations</span>
                    <span><b className="text-ivory">{t.members}</b> members</span>
                    <span>Est. <b className="text-ivory">{t.founded}</b></span>
                    <span>Gotra · <b className="text-ivory">{t.gotra}</b></span>
                  </div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
